import * as React from "react";

export function Arrew(props) {
  return (
    <svg
      width={34}
      height={37}
      viewBox="0 0 34 37"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
         fillRule="evenodd"
          clipRule="evenodd"
        d="M30.85 13.682L7.472.67c-4.772-2.656-9.739 3.17-6.36 7.461l5.374 6.829a5 5 0 010 6.184L1.11 27.972c-3.378 4.292 1.589 10.117 6.361 7.461l23.38-13.013c3.424-1.906 3.424-6.832 0-8.738z"
        fill="currentColor"
      />
    </svg>
  );
}
